module.exports = __webpack_public_path__ + "media/images/flags/mu-8b3d8f4ab3413f7bdd4d6058e068deb5.svg";